import { useOrchestrator } from '../core/context';
export function useOrchestratorNavigation() {
  const {
    next,
    skip,
    back,
    canGoBack,
    canGoNext,
    currentStepIndex,
    totalSteps,
    isComplete,
    isLoading,
    reset
  } = useOrchestrator();
  return {
    next,
    skip,
    back,
    canGoBack,
    canGoNext,
    currentStepIndex,
    totalSteps,
    isComplete,
    isLoading,
    reset
  };
}
//# sourceMappingURL=useOrchestratorNavigation.js.map